/** @format */

import { useContext } from "react";
import useLoginHooks from "../../hooks/useLoginHooks";
import { Context } from "../../stores/Provider";
import { LoginElement } from "../../components/ui_elements";
import { Container } from "../../components/layouts/Container";
import { ErrorHandler } from "../../api/ErrorHandler";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";
import { loginResponseType, ApiResponseType } from "../../@types";

const Login = () => {
  const { state } = useContext(Context);
  const { navigateByAgent } = useNavigateByAgent();
  const { ErrorHandle } = ErrorHandler(navigateByAgent);
  const { errMsgs, zAccountName, zAccount, LoginMethod, normal, abnormal, setPasswordHandler, setEmailHandler } =
    useLoginHooks(navigateByAgent);

  const apiErrMsg = state.auth;

  const loginHandler = async () => {
    const response = await LoginMethod();
    ErrorHandle<ApiResponseType<loginResponseType>>(response, normal, abnormal, true);
  };

  return (
    <Container>
      <LoginElement
        {...{
          loginHandler,
          setEmailHandler,
          setPasswordHandler,
          errMsgs,
          apiErrMsg,
          zAccountName,
          zAccount,
        }}
      />
    </Container>
  );
};

export default Login;
